import { render, staticRenderFns } from "./HqHrJiangliTypeForm.vue?vue&type=template&id=8d90bfde"
import script from "./HqHrJiangliTypeForm.vue?vue&type=script&lang=js"
export * from "./HqHrJiangliTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports